import type { CSSProperties, ReactNode } from 'react';

const cardShell: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  border: '1px solid #e5e7eb',
  borderRadius: 6,
  background: '#fff',
  boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)',
};
const wrapper: CSSProperties = {
  width: '100%',
  height: '100%',
  backgroundColor: '#ECEEF2',
  padding: '0 8px 8px 8px',
  boxSizing: 'border-box',
};

export const MOBILE_CARD_BAND = '#ECEEF2';

/**
 * Mobile grid row card: grey gutter band, white bordered card, fixed height
 * (the grid's mobileTableProps.rowHeight) so scrolling is deterministic.
 * Unloaded (skeleton) rows render the same shell blank, pulsing.
 */
const MobileCard = ({ loaded, children }: { loaded: boolean; children?: ReactNode }) => {
  if (!loaded) {
    return (
      <div style={wrapper}>
        <div className='palmetto-skeleton-pulse' style={{ ...cardShell, height: '100%' }} />
      </div>
    );
  }
  return (
    <div style={{ ...wrapper, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div
        style={{
          ...cardShell,
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          padding: '12px',
        }}>
        {children}
      </div>
    </div>
  );
};

export const CardTitle = ({ children }: { children: ReactNode }) => (
  <span
    style={{
      fontSize: 16,
      fontWeight: 700,
      color: 'rgba(0, 0, 0, 0.87)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }}>
    {children}
  </span>
);

export const CardMeta = ({ children, strong }: { children: ReactNode; strong?: boolean }) => (
  <span
    style={{
      fontSize: 14,
      fontWeight: strong ? 700 : 400,
      color: strong ? 'rgba(0,0,0,0.87)' : '#64748B',
    }}>
    {children}
  </span>
);

export const CardRow = ({ children, top }: { children: ReactNode; top?: number }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 8,
      paddingTop: top ?? 8,
    }}>
    {children}
  </div>
);

export default MobileCard;
